// Shared, deduped cart snapshot — all concurrent callers get the same in-flight GET /cart.js.
// Events carrying detail.cart update the cache instantly (no extra fetch needed).
(function () {
  var _pending = null;
  var _cache   = null;
  var _cacheTs = 0;
  var _TTL     = 3000; // ms — treat cart data as fresh for 3 s

  window.ccGetCartSnapshot = function () {
    var now = Date.now();
    if (_cache && (now - _cacheTs) < _TTL) return Promise.resolve(_cache);
    if (_pending) return _pending;
    var root = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
    _pending = fetch(root + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { _pending = null; _cache = c; _cacheTs = Date.now(); return c; })
      .catch(function ()  { _pending = null; return null; });
    return _pending;
  };

  // Keep the cache warm whenever any listener already has the fresh cart
  document.addEventListener('on:cart:change', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart) { _cache = cart; _cacheTs = Date.now(); }
    else       { _cache = null; }
  });
})();

/**
 * Require both a valid postcode (rates fetched) AND a delivery date before checkout.
 * Handles the cart drawer and the cart page.
 */
(function () {
  'use strict';

  var debounceTimer;

  var MSG_BOTH    = 'Please enter a postcode and select a delivery date to checkout.';
  var MSG_POSTCODE = 'Please enter a postcode to checkout.';
  var MSG_DATE     = 'Please select a delivery date to checkout.';

  function readFreeShippingThresholdCents(drawer) {
    var fromDrawer = drawer && parseInt(drawer.getAttribute('data-cc-free-shipping-threshold') || '0', 10);
    if (!Number.isNaN(fromDrawer) && fromDrawer > 0) return fromDrawer;
    var bar = document.querySelector('#free-shipping-notice [data-minimum]');
    if (!bar) return 0;
    var fromBar = parseInt(bar.getAttribute('data-minimum') || '0', 10);
    return Number.isNaN(fromBar) ? 0 : fromBar;
  }

  function getBlockingMessage(dateOk, postcodeOk) {
    if (!postcodeOk && !dateOk) return MSG_BOTH;
    if (!postcodeOk) return MSG_POSTCODE;
    return MSG_DATE;
  }

  function hideMsgEl(msgEl) {
    if (!msgEl) return;
    if (msgEl._hideTimer) { clearTimeout(msgEl._hideTimer); msgEl._hideTimer = null; }
    msgEl.setAttribute('hidden', '');
    msgEl.textContent = '';
  }

  /* ── Cart Drawer ─────────────────────────────────────────────────────────── */

  function syncDrawerCheckoutButtonState(cart) {
    var drawer = document.getElementById('cart-drawer');
    var btn = drawer && drawer.querySelector('button[name="checkout"].cart-drawer__checkout-btn--figma');
    if (!btn) return;

    if (!cart || !cart.item_count) { btn.disabled = true; return; }

    var ship = drawer.querySelector('[data-ship-date-input]');
    if (!ship) { btn.disabled = false; return; }

    var dateOk = String(ship.value || '').trim().length > 0;
    var postcodeOk = window.ccPostcodeShippingRatesValid === true;
    var allOk = dateOk && postcodeOk;

    btn.disabled = !allOk;

    // When conditions are met, dismiss any message the user triggered
    if (allOk) hideMsgEl(drawer.querySelector('[data-cc-checkout-gate-msg]'));
  }

  function syncDrawerCheckoutMoneyAndSuffix(cart) {
    var drawer = document.getElementById('cart-drawer');
    var btn = drawer && drawer.querySelector('button[name="checkout"].cart-drawer__checkout-btn--figma');
    if (!btn || !cart) return;

    var suffixEl = btn.querySelector('.cart-drawer__checkout-suffix');
    if (!suffixEl) return;

    var th = readFreeShippingThresholdCents(drawer);
    var s = (window.theme && window.theme.strings) || {};
    var plusShip = s.checkoutPlusShipping || '+ Shipping';
    var plusFree = s.checkoutPlusFreeShipping || '+ Free Shipping';

    var orderMeetsFreeShippingBar = th > 0 && Number(cart.total_price) >= th;
    var isFree = orderMeetsFreeShippingBar || window.ccPostcodeShippingRatesValid !== true;
    suffixEl.textContent = isFree ? plusFree : plusShip;
  }

  /* ── Cart Page ───────────────────────────────────────────────────────────── */

  function getCartPageShipInput() {
    var drawer = document.getElementById('cart-drawer');
    var inputs = document.querySelectorAll('[data-ship-date-input]');
    for (var i = 0; i < inputs.length; i++) {
      if (!drawer || !drawer.contains(inputs[i])) return inputs[i];
    }
    return null;
  }

  function getCartPagePostcodeChecker() {
    var drawer = document.getElementById('cart-drawer');
    var checkers = document.querySelectorAll('cart-postcode-checker');
    for (var i = 0; i < checkers.length; i++) {
      if (!drawer || !drawer.contains(checkers[i])) return checkers[i];
    }
    return null;
  }

  function syncCartPageCheckoutButtonState(cart) {
    var summary = document.getElementById('cart-summary');
    if (!summary) return;
    var btn = summary.querySelector('button[name="checkout"]');
    if (!btn) return;

    if (!cart || !cart.item_count) { btn.disabled = true; return; }

    var ship = getCartPageShipInput();
    var checker = getCartPagePostcodeChecker();

    // If neither picker is on the cart page, don't block
    if (!ship && !checker) { btn.disabled = false; return; }

    var dateOk = ship ? String(ship.value || '').trim().length > 0 : true;
    var postcodeOk = window.ccPostcodeShippingRatesValid === true;
    var allOk = dateOk && postcodeOk;

    btn.disabled = !allOk;

    // When conditions are met, dismiss any message the user triggered
    if (allOk) hideMsgEl(summary.querySelector('[data-cc-checkout-gate-msg]'));
  }

  /* ── Click feedback (only show message when user tries to click a blocked button) ── */

  function showGateMsg(msgEl, dateOk, postcodeOk) {
    if (!msgEl) return;
    if (msgEl._hideTimer) clearTimeout(msgEl._hideTimer);
    msgEl.textContent = getBlockingMessage(dateOk, postcodeOk);
    msgEl.removeAttribute('hidden');
    msgEl._hideTimer = setTimeout(function () {
      msgEl.setAttribute('hidden', '');
    }, 4000);
  }

  function attachDrawerClickFeedback() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var btn = drawer.querySelector('button[name="checkout"].cart-drawer__checkout-btn--figma');
    if (!btn || btn._ccGateFeedback) return;
    btn._ccGateFeedback = true;

    btn.addEventListener('pointerdown', function () {
      if (!btn.disabled) return;
      var ship = drawer.querySelector('[data-ship-date-input]');
      var dateOk = ship ? String(ship.value || '').trim().length > 0 : true;
      var postcodeOk = window.ccPostcodeShippingRatesValid === true;
      showGateMsg(drawer.querySelector('[data-cc-checkout-gate-msg]'), dateOk, postcodeOk);
    });
  }

  function attachCartPageClickFeedback() {
    var summary = document.getElementById('cart-summary');
    if (!summary) return;
    var btn = summary.querySelector('button[name="checkout"]');
    if (!btn || btn._ccGateFeedback) return;
    btn._ccGateFeedback = true;

    btn.addEventListener('pointerdown', function () {
      if (!btn.disabled) return;
      var ship = getCartPageShipInput();
      var dateOk = ship ? String(ship.value || '').trim().length > 0 : true;
      var postcodeOk = window.ccPostcodeShippingRatesValid === true;
      showGateMsg(summary.querySelector('[data-cc-checkout-gate-msg]'), dateOk, postcodeOk);
    });
  }

  /* ── Combined run ────────────────────────────────────────────────────────── */

  function run(ev) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      var detailCart = ev && ev.detail && ev.detail.cart;
      var cartPromise = detailCart
        ? Promise.resolve(detailCart)
        : typeof window.ccGetCartSnapshot === 'function'
          ? window.ccGetCartSnapshot()
          : fetch(((window.theme && theme.routes && theme.routes.cart) || '/cart') + '.js').then(function (r) {
              return r.ok ? r.json() : null;
            });

      cartPromise
        .then(function (cart) {
          syncDrawerCheckoutButtonState(cart);
          syncDrawerCheckoutMoneyAndSuffix(cart);
          syncCartPageCheckoutButtonState(cart);
          attachDrawerClickFeedback();
          attachCartPageClickFeedback();
        })
        .catch(function () {
          syncDrawerCheckoutButtonState(null);
          syncCartPageCheckoutButtonState(null);
        });
    }, 32);
  }

  window.syncCartDrawerCheckoutGate = run;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('on:cart:change', run);
  document.addEventListener('cc:cart-shipping-surcharge-updated', run);
})();
